import { Group } from '@mantine/core';
import { ReactElement } from 'react';

interface Props {
  icon: ReactElement;
  label: string;
  color?: string;
}

export const TableColumnWithIcon = ({ icon, label, color }: Props) => {
  return (
    <Group gap={'xs'} mr={0} c={color}>
      {icon}
      {label}
    </Group>
  );
};
